import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { Title, ParagraphMd } from '@olist/design-system';
import { DescriptionWrapper } from './styles.js';
import { DataTable } from '../DataTable/index.js';
import '@olist/design-system-icons';
import '../ApplicationLayout/styles.js';
import '../PageLayout/styles.js';
import '../PageLoading/styles.js';

function PageList(_a) {
    var { description, filter, isLoading = false, isEmpty = false, isError = false, pagination, title, table, header } = _a, props = __rest(_a, ["description", "filter", "isLoading", "isEmpty", "isError", "pagination", "title", "table", "header"]);
    const shouldShowHeader = (filter === null || filter === void 0 ? void 0 : filter.form) && !header;
    return (React.createElement(DataTable.Container, null,
        React.createElement(Title, { mb: "8px" }, title),
        typeof description === 'string' ? (React.createElement(DescriptionWrapper, null,
            React.createElement(ParagraphMd, null, description))) : (description),
        shouldShowHeader ? (React.createElement(DataTable.TableHeader, null,
            React.createElement(DataTable.Filter, Object.assign({}, filter), filter === null || filter === void 0 ? void 0 : filter.form))) : (header),
        React.createElement(DataTable.Table, Object.assign({ columns: table.columns, rows: table.rows, isLoading: isLoading, isEmpty: isEmpty, isError: isError }, props))));
}

export { PageList };
